import React, { CSSProperties, FC } from 'react';
import { CompanyRespWithSettingAttributes } from '~src/interfaces/company.interface';
import { SegmentType } from '~src/interfaces/segment.interface';
import { SessionUserI } from '~src/interfaces/session.types';

import { getUserFullName } from '~src/interfaces/user.interface';
import AvatarBox, { AvatarType } from '~src/shared/avatarBox/AvatarBox';
import { SideBarItemI } from '~src/shared/sidebar/constants/sideBarData';
import { IconContainer } from '~src/shared/sidebar/styles/sidebar.sc';
import { RedDot } from '~src/shared/sidebar/styles/sidebarItem.sc';
import { StyledSideBarLink } from '~src/shared/sidebar/styles/subnav.sc';
import SvgIcon from '~src/shared/SvgIcon';

interface SharedProps {
  menuItem: SideBarItemI;
  isSelected: boolean;
  defaultUrl: string;
  style?: CSSProperties;
  viewBoxWidth?: number;
}

type UProps = SharedProps & { user: SessionUserI };
type CProps = SharedProps & { company: CompanyRespWithSettingAttributes; showRedDot: boolean };
type SProps = SharedProps;
type IProps = SharedProps;

const AvatarBarItem: FC<SharedProps & { name: string; type: AvatarType; imageUrl: string | null }> = (
  props,
) => (
  <StyledSideBarLink to={props.defaultUrl}>
    <IconContainer $selected={props.isSelected}>
      <AvatarBox size={33} type={props.type} name={props.name} url={props.imageUrl} />
      {props.children}
    </IconContainer>
  </StyledSideBarLink>
);

export const UserSideBarItem: FC<UProps> = (props) => (
  <AvatarBarItem
    {...props}
    name={getUserFullName(props.user)}
    type={SegmentType.User}
    imageUrl={props.user.imageUrl}
  />
);

export const CompanySideBarItem: FC<CProps> = (props) => (
  <AvatarBarItem
    {...props}
    name={props.company.name}
    type={SegmentType.Company}
    imageUrl={props.company.imageUrl}
  >
    {props.showRedDot && <RedDot />}
  </AvatarBarItem>
);

export const SimpleIconBarItem: FC<SProps> = (props) => (
  <IconContainer $selected={props.isSelected}>
    <SvgIcon width="25px" viewBoxWidth={props.viewBoxWidth} name={props.menuItem.icon} />
  </IconContainer>
);

export const LinkedIconBarItem: FC<IProps> = (props) => {
  const onClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (props.defaultUrl.indexOf('http') === 0) {
      e.preventDefault();
      e.stopPropagation();
      document.location.assign(props.defaultUrl);
    }
  };

  return (
    <StyledSideBarLink onClick={onClick} to={props.defaultUrl}>
      <SimpleIconBarItem {...props} />
    </StyledSideBarLink>
  );
};
